'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import CardAppointment from './card-appointment/card-appointment.component';
import CardAppointmentLoading from './card-appointment/variants/_components/appointment-loading.component';

import { Appointment } from '@/types/appointments.types';
import { useInView } from '@/hooks/use-inview.hook';
import { useLoading } from '@/hooks/use-loading.hook';

interface AppointmentCardQueryParams {
  appointment?: Partial<Appointment>;
  fetchAppointmentById: () => void;
  onAppointmentUpdate: (appointment: Partial<Appointment>) => void;
}

export function AppointmentCardQuery({
  appointment,
  fetchAppointmentById,
  onAppointmentUpdate,
}: AppointmentCardQueryParams) {
  const { isLoading, startLoading, stopLoading } = useLoading();
  const { inviewRef } = useInView({
    callback: async () => {
      if (isLoading) {
        return;
      }
      startLoading();
      await fetchAppointmentById();
      stopLoading();
    },
  });

  return (
    <div data-testid={`${DataTestIdEnum.APPOINTMENT_CARD_CONTAINER}-${appointment?.id}`} className="w-full">
      {appointment && Object.keys(appointment).length > 3 && !isLoading
        ? (
            <CardAppointment
              appointment={appointment as Appointment}
              defaultOpen={false}
              onAppointmentUpdate={onAppointmentUpdate}
            />
          )
        : (
            <CardAppointmentLoading isOpen={false} ref={inviewRef} />
          )}
    </div>
  );
}
